import { createEntityAdapter, EntityState } from "@magicware/redux/entities";
import { anchoreThunks, AsyncSliceState } from "@magicware/redux/thunks";
import { createSlice } from "@reduxjs/toolkit";
import {
    entityApi,
    ParametersScopeModelDetail,
    ParametersScopeFilter,
    ParametersScopeModelList,
} from "../../services/api/parametersScopes";
import { RootState } from "../types";

export interface State
    extends EntityState<ParametersScopeModelDetail, ParametersScopeModelList, ParametersScopeFilter>,
        AsyncSliceState {}

const initialState: State = { async: {} };

const adapter = createEntityAdapter("parametersScopes", entityApi, ["name", "type"]);

const extraThunks = {};

const slice = createSlice({
    name: "parametersScopes",
    initialState,
    reducers: adapter.getReducers(),
    extraReducers: (builder) => {
        adapter.addExtraReducers(builder);
        //addAsyncThunkReducers(builder, extraThunks.xxx);
    },
});

export const parametersScopeThunks = anchoreThunks((state: RootState) => state.parametersScopes, {
    ...extraThunks,
    ...adapter.thunks,
});

export const actions = slice.actions;
export const { updateDetail, clearList, removeListItems, updateListItems, setPage } = slice.actions;
export default slice.reducer;
